import React from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";

const fetchProduct = async (id) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/products/${id}`
  );
};

export default function ProductsPage() {
  const { id } = useParams();
  const { data, isLoading, isError, error, status } = useQuery(
    ["product", id],
    () => fetchProduct(id),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    }
  );

  if (isLoading) return <h1>Loading...</h1>;
  if (error) return <h1>{error}</h1>;

  return (
    <Wrapper>
      <ImageWrapper>
        {
          // render all images
          data.data.data.product.images.map((image) => {
            return (
              <div>
                <img src={image} alt="" />
              </div>
            );
          })
        }
      </ImageWrapper>
      <ProductDetailsWrapper>
        <h1>{data.data.data.product.name}</h1>
        <p>Price: GHC{data.data.data.product.price}</p>
        <p>Description: {data.data.data.product.description}</p>
        <FarmerDetails>
          <h1>Farmer Details</h1>
          <p>Name: Mr. Kofi Kyeremeh</p>
          <p>Phone: 0508936547</p>
          <p>Address: Kumasi</p>
        </FarmerDetails>
      </ProductDetailsWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
`;

const ImageWrapper = styled.div`
  display: grid;
  grid-template-areas: "image1 image2" "image3 image4";
  grid-template-columns: repeat(2, 1fr);
  border-radius: 1rem;
  overflow: hidden;
  gap: 1rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ProductDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  p {
    font-size: 1.6rem;
  }

  h1 {
    margin: 0.5rem 0;
    color: #3cc830;
  }
`;

const FarmerDetails = styled.div``;
